import { render, staticRenderFns } from "./PredmetList.vue?vue&type=template&id=938752e6&scoped=true&"
import script from "./PredmetList.vue?vue&type=script&lang=js&"
export * from "./PredmetList.vue?vue&type=script&lang=js&"
import style0 from "./PredmetList.vue?vue&type=style&index=0&id=938752e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938752e6",
  null
  
)

export default component.exports